import EventComponent from './EventComponent'


/* START OF COMPILED CODE */

/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class SimpleButton extends EventComponent {

    constructor(gameObject) {
        super(gameObject);

        /** @type {Phaser.GameObjects.Sprite} */
        this.gameObject;
        /** @type {any} */
        this.hoverCallback = null;
        /** @type {any} */
        this.hoverOutCallback = null;
        /** @type {any} */
        this.callback = () => {};
        /** @type {boolean} */
        this.pixelPerfect = false;
        /** @type {boolean} */
        this.handCursor = true;
        /** @type {boolean} */
        this.enableClickSfx = true;
        /** @type {boolean} */
        this.enableHoverSfx = false;
        /** @type {string} */
        this.clickSfxKey = 'ui-button-click';
        /** @type {string} */
        this.hoverSfxKey = 'ui-hover';
        /** @type {number} */
        this.sfxVolume = 0.35;


        this.gameObject = gameObject;
        gameObject["__SimpleButton"] = this;

        /* START-USER-CTR-CODE */

        gameObject.isButton = true

        /* END-USER-CTR-CODE */
    }

    /** @returns {SimpleButton} */
    static getComponent(gameObject) {
        return gameObject["__SimpleButton"];
    }


    /* START-USER-CODE */

    start() {
        this.setInteractive()

        this.gameObject.on('pointerover', () => this.onOver())
        this.gameObject.on('pointerout', () => this.onOut())
        this.gameObject.on('pointerup', (pointer) => this.onUp(pointer))
    }

    setInteractive() {
        // Input already enabled by Hit Area tool
        if (this.gameObject.input && this.gameObject.input.enabled) {
            this.gameObject.input.cursor = 'pointer'
            return
        }

        this.gameObject.setInteractive({
            cursor: this.handCursor ? 'pointer' : 'default',
            pixelPerfect: this.pixelPerfect
        })
    }

    onOver() {
        // Play hover sound if enabled
        if (this.enableHoverSfx) {
            this.playSfx(this.hoverSfxKey, this.sfxVolume * 0.5)
        }
        
        if (this.hoverCallback) this.hoverCallback()
    }

    onOut() {
        if (this.hoverOutCallback) this.hoverOutCallback()
    }

    onUp(pointer) {
        if (pointer.button != 0) {
            return
        }

        // Play click sound if enabled
        if (this.enableClickSfx) {
            this.playSfx(this.clickSfxKey, this.sfxVolume)
        }

        if (this.callback) this.callback()
    }

    /**
     * Play a UI sound effect
     * @param {string} key - Sound key
     * @param {number} volume - Volume (0-1)
     */
    playSfx(key, volume = 0.35) {
        try {
            const scene = this.gameObject.scene
            if (scene && scene.soundManager && scene.cache.audio.exists(key)) {
                scene.soundManager.playSfx(key, { volume, allowOverlap: true })
            }
        } catch (e) {
            // Silently fail if sound system not available
        }
    }

    /* END-USER-CODE */
}

/* END OF COMPILED CODE */
